<div class="wall-camera" #fullScreenContainer>
  <app-inactivity
    *ngIf="wallInactive() && viewTab() === WallViewTab.Live"
    class="wall-camera__inactivity-overlay"
    [countDown]="false"
    [inactive]="wallInactive()"
    [localOnly]="true"
    [playback]="true"
    (resume)="wallResumePlay()"
  ></app-inactivity>

  <div class="wall-camera__header">
    <span class="wall-camera__name" [title]="request()?.name">{{ request()?.name }}</span>

    <div class="wall-camera__actions">
      <div
        class="wall-camera__view-toggle"
        *ngIf="!isLoading() && !hasError() && tiles().length > 0"
      >
        <button
          type="button"
          class="wall-camera__view-toggle-btn"
          [class.wall-camera__view-toggle-btn--active]="viewTab() === WallViewTab.Live"
          (click)="setViewTab(WallViewTab.Live)"
        >
          {{ 'SEARCH_GLOBAL_MODAL.WALL_CAMERA_RESULT.LIVE_VIEW' | translate }}
        </button>
        <button
          type="button"
          class="wall-camera__view-toggle-btn"
          [class.wall-camera__view-toggle-btn--active]="viewTab() === WallViewTab.Playback"
          (click)="setViewTab(WallViewTab.Playback)"
        >
          {{ 'SEARCH_GLOBAL_MODAL.WALL_CAMERA_RESULT.PLAYBACK' | translate }}
        </button>
      </div>
      <div
        class="wall-camera__view-toggle"
        *ngIf="!isLoading() && !hasError() && tiles().length > 0"
      >
        <button
          type="button"
          class="wall-camera__view-toggle-btn wall-camera__view-toggle-btn--icon"
          [class.wall-camera__view-toggle-btn--active]="gridViewMode() === WallGridViewMode.Grid"
          [matTooltip]="'SEARCH_GLOBAL_MODAL.WALL_CAMERA_RESULT.GRID_VIEW' | translate"
          (click)="setGridViewMode(WallGridViewMode.Grid)"
        >
          <span class="ui-icon-wall-sidebar"></span>
        </button>
        <button
          type="button"
          class="wall-camera__view-toggle-btn wall-camera__view-toggle-btn--icon"
          [class.wall-camera__view-toggle-btn--active]="gridViewMode() === WallGridViewMode.Layout"
          [matTooltip]="'SEARCH_GLOBAL_MODAL.WALL_CAMERA_RESULT.LAYOUT_VIEW' | translate"
          (click)="setGridViewMode(WallGridViewMode.Layout)"
        >
          <span class="ui-icon-dashboards-sidebar"></span>
        </button>
      </div>
      <span
        *ngIf="wall() && !isLoading() && !hasError()"
        class="wall-camera__action ui-icon-edit"
        [matTooltip]="'SEARCH_GLOBAL_MODAL.EDIT_WALL' | translate"
        (click)="editWall()"
      ></span>
      <span
        *ngIf="wall() && !isLoading() && !hasError()"
        class="wall-camera__action ui-icon-new-tab"
        [matTooltip]="'SEARCH_GLOBAL_MODAL.WALL_CAMERA_RESULT.OPEN_WALL' | translate"
        (click)="openWallPage()"
      ></span>
      <span
        class="wall-camera__action"
        [class.ui-icon-mute]="muted()"
        [class.ui-icon-speaker]="!muted()"
        [matTooltip]="(muted() ? 'COMMON.UNMUTE' : 'COMMON.MUTE') | translate"
        (click)="toggleMute()"
      ></span>
      <span
        class="wall-camera__action ui-icon-fullscreen-2"
        [matTooltip]="'COMMON.FULLSCREEN' | translate"
        (click)="fullScreen()"
      ></span>
    </div>
  </div>

  <div class="wall-camera__sets" *ngIf="sets().length > 1">
    <button
      type="button"
      class="wall-camera__set"
      *ngFor="let set of sets(); let i = index; trackBy: trackBySetIndex"
      [class.wall-camera__set--active]="i === activeSetIndex()"
      [class.wall-camera__set--disabled]="hasWallAlert()"
      (click)="selectSet(i)"
    >
      {{ set.name || ('SEARCH_GLOBAL_MODAL.WALL_CAMERA_RESULT.SET' | translate) + ' ' + (i + 1) }}
    </button>
  </div>

  <div class="wall-camera__state" *ngIf="isLoading()">
    <ui-preloader [color]="PreloaderColor.gray" [diameter]="24"></ui-preloader>
    <span>{{ 'SEARCH_GLOBAL_MODAL.WALL_CAMERA_RESULT.LOADING' | translate }}</span>
  </div>

  <div class="wall-camera__state" *ngIf="hasError()">
    {{ 'SEARCH_GLOBAL_MODAL.WALL_CAMERA_RESULT.ERROR' | translate }}
  </div>

  <div
    class="wall-camera__state"
    *ngIf="!isLoading() && !hasError() && tiles().length === 0"
  >
    {{ 'SEARCH_GLOBAL_MODAL.WALL_CAMERA_RESULT.NO_CAMERAS' | translate }}
  </div>

  <div class="wall-camera__alerts" *ngIf="hasWallAlert() && !isLoading() && !hasError()">
    <alerts-incoming-v2
      [alerts]="tableAlerts$ | async"
      [locationLookup]="locationLookup$ | async"
    ></alerts-incoming-v2>
  </div>

  <div
    class="wall-camera__grid"
    *ngIf="gridViewMode() === WallGridViewMode.Grid && !isLoading() && !hasError() && tiles().length > 0"
    [style.grid-template-columns]="'repeat(' + gridColumns() + ', 1fr)'"
  >
    <div
      class="wall-camera__tile"
      *ngFor="let tile of tiles(); let i = index; trackBy: trackByTileIndex"
      #tileEl
      (click)="openTileFullscreen(tileEl, tile)"
    >
      <v2-wall-tile
        *ngIf="isAlertTile(tile); else standardTile"
        class="wall-camera__alert-tile"
        [index]="i"
        [tile]="tile"
        [viewMode]="true"
        [checkPermissions]="false"
      ></v2-wall-tile>

      <ng-template #standardTile>
        <div
          class="wall-camera__tile-index"
          *ngIf="tileSettings()?.showTileNumber"
          [class.wall-camera__tile-index--camera]="!!tile.camera?.cameraId"
        >
          {{ i + 1 }}
        </div>

        <webrtc-player
          *ngIf="tile.camera?.cameraId; else emptyTile"
          #player
          class="wall-camera__player"
          [isWall]="true"
          [autostart]="true"
          [showControls]="viewTab() === WallViewTab.Playback"
          [wallPlaybackEnabled]="viewTab() === WallViewTab.Playback"
          [playback]="viewTab() === WallViewTab.Playback"
          [playbackTS]="playbackTs() ?? undefined"
          [playbackSeek]="true"
          [isExternallyManaged]="true"
          [allowZoom]="false"
          [enableQualitySelection]="false"
          [edgeId]="tile.camera?.edgeId"
          [cameraId]="tile.camera?.cameraId"
          [locationId]="tile.camera?.locationId"
          [cameraName]="cameraName(tile.camera?.cameraId)"
          [showCameraName]="tileSettings()?.showCameraName ?? true"
          [showTime]="tileSettings()?.showTimestamp ?? false"
          [showCameraStatus]="tileSettings()?.showCameraStatus ?? true"
          [audioEnabled]="!muted()"
          [isMainPlayer]="false"
          [isRespectRatio]="tile.fixedSettings?.keepRatio ?? false"
        ></webrtc-player>

        <ng-template #emptyTile>
          <span class="wall-camera__tile-empty ui-icon-camera"></span>
        </ng-template>
      </ng-template>
    </div>
  </div>

  <v2-set-layout
    *ngIf="gridViewMode() === WallGridViewMode.Layout && !isLoading() && !hasError() && currentSet()"
    class="wall-camera__layout"
    [set]="currentSet()"
    [viewMode]="true"
    [checkPermissions]="false"
  ></v2-set-layout>

  <div
    class="wall-camera__timeline"
    *ngIf="!isLoading() && !hasError() && tiles().length > 0 && viewTab() === WallViewTab.Playback"
  >
    <timeline
      class="w-100"
      [isWall]="true"
      [isWallCompactTimeView]="true"
      [visibleRows]="3"
      [startTime]="playbackStartTs()"
      [endTime]="playbackEndTs()"
      [layout]="currentSet()?.layout"
      [zoomEnabled]="true"
      [videoSection]="false"
      [isCameraView]="true"
      [streamLiveView]="false"
      [timezone]="timezone"
      [initTs]="playbackTs() ?? undefined"
      [isPlaying]="!videoService.isPaused"
      (seekStart)="onWallSeekStart()"
      (seekEnd)="onWallSeekEnd($event)"
      (timelineDragStart)="onWallTimelineDragStart()"
      (timelineDragEnd)="onWallTimelineDragEnd($event)"
      (play)="onWallPlaybackPlay()"
      (userPause)="onWallPlaybackPause()"
    ></timeline>
  </div>
</div>
